const setting = {
  amapKey: '6ef0e4f65df5233b3473b7cfcf74b33b', // 地图key
  amapJsCode: 'c750d3ce7a81492b54008a2c9364b2e9' ,// 地图安全密钥
  appid: 2,
  deviceTypeId: 'devicePart',
}

export default setting